import React, { FC, PropsWithChildren, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast'
import axiosInstance, { axiosIamInstance } from '../../services/http-common'
import { useAuth } from '../../context/AuthContext'

const ErrorHandlingInterceptor: FC<PropsWithChildren> = ({ children }) => {
  const navigate = useNavigate()
  const { fetchSession } = useAuth()

  // const [errorMessage, setErrorMessage] = useState('An error occurred!')

  useEffect(() => {
    const authInterceptor = async (error: any) => {
      if (error.code === 'ERR_NETWORK') {
        throw error
      } else if (error.response?.status === 401) {
        fetchSession()
      } else if (error.response?.status === 404) {
        toast.error('Resources not found!')
      } else if (error.response?.status === 403) {
        navigate('/not-authorized', { replace: true })
        toast.error('Not authorized!')
      } else if (error.response?.status === 500) {
        toast.error('Server error occurred!')
      } else if (error.response?.status === 400) {
        toast.error('Bad request!')
        if (error.response?.data?.errorMessage) {
          toast.error(error.response?.data?.errorMessage)
        }
      } else {
        toast.error('Something went wrong!')
      }
      console.error(error)
      throw error
    }

    const httpInterceptor = axiosInstance.interceptors.response.use(async (response) => response, authInterceptor)
    const iamInterceptor = axiosIamInstance.interceptors.response.use(async (response) => response, authInterceptor)

    return () => {
      axiosInstance.interceptors.response.eject(httpInterceptor)
      axiosIamInstance.interceptors.response.eject(iamInterceptor)
    }
  }, [navigate, fetchSession])

  return <div>{children}</div>
}

export default ErrorHandlingInterceptor
